import { render, staticRenderFns } from "./CourseSelect.vue?vue&type=template&id=ea706256&scoped=true&"
import script from "./CourseSelect.vue?vue&type=script&lang=js&"
export * from "./CourseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea706256",
  null
  
)

export default component.exports